import DataCortex from 'browser-data-cortex';

export default {
  log: DataCortex.log,
  preInit,
  init,
  addUserTag: DataCortex.addUserTag,
  loadFinish,
  showScreen,
  facebookLoginSuccess,
  gameLoginSuccess,
  promoClick,
};

function preInit(done) {
  const opts = {
    api_key: process.env.DC_API_KEY,
    org_name: process.env.DC_ORG_NAME,
    app_ver: process.env.VERSION,
    add_error_handler: true,
  };
  DataCortex.init(opts);
  done && done();
}
function init() {}

function loadFinish() {
  const event = {
    kingdom: 'game',
    phylum: 'load_finish',
  };
  DataCortex.event(event);
}

function facebookLoginSuccess() {
  const event = {
    kingdom: 'game',
    phylum: 'facebook_login_success',
  };
  DataCortex.event(event);
}
function gameLoginSuccess() {
  const event = {
    kingdom: 'game',
    phylum: 'game_login_success',
  };
  DataCortex.event(event);
}
function showScreen(screen_name: string) {
  const event = {
    kingdom: 'game',
    phylum: 'show_screen',
    class: screen_name,
  };
  DataCortex.event(event);
}
function promoClick(promo_name: string) {
  const event = {
    kingdom: 'promo',
    phylum: 'click',
    class: promo_name,
  };
  DataCortex.event(event);
}
